import api from '@/factories/api';
import cloneDeep from 'lodash/cloneDeep';
import { updateArrInStore } from '@/store/storeHelpers';

export default {
  namespaced: true,

  state: {
    folders: [],
    foldersLoaded: false,
    lessonsLoading: false,
  },

  getters: {
    getFolder(state) {
      return (folderId) => state.folders.find((i) => i.id === folderId);
    },
  },

  mutations: {
    setFolders: (state, folders) => {
      state.folders = folders;
    },
    syncFolderChanges: (state, folder) => {
      updateArrInStore(state, folder, 'folders');
    },
    setFoldersLoaded: (state, loaded) => {
      state.foldersLoaded = loaded;
    },
    setLessonsLoading: (state, loading) => {
      state.lessonsLoading = loading;
    },
  },

  actions: {
    async loadFolders({ commit, state }, schema = 'small') {
      if (state.foldersLoaded) return;

      try {
        const folders = await api().get(`cg/lessons_folders?schema=${schema}`);
        commit('setFolders', folders);
      } finally {
        commit('setFoldersLoaded', true);
      }
    },

    async loadFolderLessons({ commit }, folderId) {
      commit('setLessonsLoading', true);
      try {
        const res = await api().get(
          `cg/lessons_folders/${folderId}?schema=full`
        );
        const folder = Array.isArray(res) ? res[0] : '';
        commit('syncFolderChanges', folder);
      } finally {
        commit('setLessonsLoading', false);
      }
    },

    updateFolder({ commit, state }, { folderId, lesson }) {
      const folder = cloneDeep(state.folders.find((i) => i.id === folderId));
      const lessonIdx = folder.lessons.findIndex((l) => l.id === lesson.id);
      folder.lessons.splice(lessonIdx, 1, lesson);
      commit('syncFolderChanges', folder);
    },
  },
};
